import type { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

import { theme } from '../../styles/theme';

interface SearchWrapperProps {
  $isOpen: boolean;
  children: ReactNode;
  'data-tour'?: string;
}

export const SearchWrapper: FC<SearchWrapperProps> = ({
  $isOpen,
  children,
  'data-tour': dataTour,
}) => (
  <Box
    data-tour={dataTour}
    sx={{
      flexShrink: 0,
      padding: theme.spacing(4),
      paddingBottom: 0,
      zIndex: 10,
      overflow: 'visible',
      display: 'none',
      [`@media (min-width: ${theme.breakPoints.desktop}px)`]: {
        display: $isOpen ? 'block' : 'none',
      },
    }}
  >
    {children}
  </Box>
);
